//switch product's variants
$(".valentine-may-like .variant-item").click(function () {
  var vid = $(this).attr("data-id");
  var vindex = $(this).attr("data-index");
  var pid = $(this).attr("data-pid");
  $(this).addClass("active").siblings().removeClass("active");
  $(".valentine-may-like .variant-wrapper[data-id=" + vid + "]")
    .addClass("active")
    .siblings()
    .removeClass("active");
  $(
    ".valentine-may-like .variant-img[data-index=" +
      vindex +
      "][data-pid=" +
      pid +
      "]",
  )
    .addClass("active")
    .siblings()
    .removeClass("active");

  $(
    ".valentine-may-like .buy-card .price[data-index=" +
      vindex +
      "][data-pid=" +
      pid +
      "]",
  )
    .addClass("active")
    .siblings()
    .removeClass("active");
});

// 阻止跳转加购
// $(function () {
//   $(".valentine-may-like .add-to-cart-form2").on("submit", function (evt) {
//     evt.preventDefault();
//     ShopifyAPI.addItemFromForm2(
//       evt.target,
//       ajaxCart.itemAddedCallback,
//       ajaxCart.itemErrorCallback,
//     );
//   });
// });

//openmeet 切换控制
$(".valentine-may-like .openmeet .toggle-product-option-item").click(
  function () {
    $(this).addClass("active").siblings().removeClass("active");
    var $this = $(this);
    setTimeout(function () {
      //usb-a 和 usb-c 和 no
      var now_product = $this.attr("data-product-handle");
      var now_type = $this.attr("data-option-size");

      $(
        ".valentine-may-like .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
          now_product +
          "']",
      )
        .addClass("active")
        .siblings()
        .removeClass("active");

      $(".valentine-may-like ." + now_product + " .color_list li").css(
        "display",
        "none",
      );
      $(
        ".valentine-may-like ." +
          now_product +
          " .color_list li[data-option2='" +
          now_type +
          "']",
      ).css("display", "block");
      var v_id = $(
        ".valentine-may-like ." +
          now_product +
          " .color_list li[data-option2='" +
          now_type +
          "']",
      )
        .eq(0)
        .attr("data-var_id");
      $(
        ".valentine-may-like ." +
          now_product +
          " .color_list li[data-option2='" +
          now_type +
          "'][data-var_id='" +
          v_id +
          "']",
      ).click();
    }, 100);
  },
);

//opencomm2uc2025upgrade 切换控制
$(
  ".valentine-may-like .opencomm2uc2025upgrade .toggle-product-option-item",
).click(function () {
  $(this).addClass("active").siblings().removeClass("active");
  var $this = $(this);
  setTimeout(function () {
    //usb-a 和 usb-c
    var now_product = $this.attr("data-product-handle");
    var now_type = $this.attr("data-option-size");

    $(
      ".valentine-may-like .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
        now_product +
        "']",
    )
      .addClass("active")
      .siblings()
      .removeClass("active");

    $(".valentine-may-like ." + now_product + " .color_list li").css(
      "display",
      "none",
    );
    $(
      ".valentine-may-like ." +
        now_product +
        " .color_list li[data-option2='" +
        now_type +
        "']",
    ).css("display", "block");
    var v_id = $(
      ".valentine-may-like ." +
        now_product +
        " .color_list li[data-option2='" +
        now_type +
        "']",
    )
      .eq(0)
      .attr("data-var_id");
    $(
      ".valentine-may-like ." +
        now_product +
        " .color_list li[data-option2='" +
        now_type +
        "'][data-var_id='" +
        v_id +
        "']",
    ).click();
  }, 100);
});

//openrun size 切换控制
$(".valentine-may-like .openrun .toggle-product-option-item").click(
  function () {
    $(this).addClass("active").siblings().removeClass("active");
    var $this = $(this);
    setTimeout(function () {
      //mini standard
      if ($this.hasClass("toggle-product-size-item")) {
        var now_product = $this.attr("data-product-handle");
        var now_size = $this.attr("data-option-size");
        var now_type = $(
          `.valentine-may-like .${now_product} .charger-port-part .toggle-product-option-item.active`,
        ).attr("data-option-size");
      } else {
        //usb-c 和 磁吸
        var now_product = $this.attr("data-product-handle");
        var now_size = $(
          `.valentine-may-like .${now_product} .toggle-product-option-size .toggle-product-option-item.active`,
        ).attr("data-option-size");
        var now_type = $this.attr("data-option-size");
      }
      $(
        ".valentine-may-like .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
          now_product +
          "'][data-option-size='" +
          now_size +
          "']",
      )
        .addClass("active")
        .siblings()
        .removeClass("active");

      $(".valentine-may-like ." + now_product + " .color_list li").css(
        "display",
        "none",
      );
      $(
        ".valentine-may-like ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "'][data-option2='" +
          now_type +
          "']",
      ).css("display", "block");
      var v_id = $(
        ".valentine-may-like ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "'][data-option2='" +
          now_type +
          "']",
      )
        .eq(0)
        .attr("data-var_id");
      $(
        ".valentine-may-like ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "'][data-option2='" +
          now_type +
          "'][data-var_id='" +
          v_id +
          "']",
      ).click();
    }, 100);
  },
);

//Openrun pro2 mini产品切换
$(".valentine-may-like .openrun-pro2 .toggle-product-option-item").click(
  function () {
    $(this).addClass("active").siblings().removeClass("active");
    var $this = $(this);
    setTimeout(function () {
      //mini standard
      var now_product = $this.attr("data-product-handle");
      var now_size = $this.attr("data-option-size");
      $(
        ".valentine-may-like .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
          now_product +
          "'][data-option-size='" +
          now_size +
          "']",
      )
        .addClass("active")
        .siblings()
        .removeClass("active");

      $(".valentine-may-like ." + now_product + " .color_list li").css(
        "display",
        "none",
      );
      $(
        ".valentine-may-like ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "']",
      ).css("display", "block");
      var v_id = $(
        ".valentine-may-like ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "']",
      )
        .eq(0)
        .attr("data-var_id");
      $(
        ".valentine-may-like ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "'][data-var_id='" +
          v_id +
          "']",
      ).click();
    }, 100);
  },
);

// Openfit2 默认选择米色
$(
  '.valentine-may-like .openfit2 .variant-item[data-var_id="51528187019597"]',
).trigger("click");

function product_page_ga4_deal_with_discount(
  product_item,
  buttom_name,
  event_name,
  discount = 0,
) {
  let $v_item_name = "";
  let $v_item_variant = "";
  let $v_item_category = "";
  let $v_item_category2 = "Standard";
  if (product_handle_map.has(product_item[0])) {
    $v_item_name = product_handle_valueMap[product_item[0]][0];
    $v_item_variant = product_handle_valueMap[product_item[0]][1];
    $v_item_category = product_handle_valueMap[product_item[0]][2];
    $v_item_category2 = product_handle_valueMap[product_item[0]][3];
  }

  let event_parameters_before = {
    item_list_id: capitalizeWords(product_item[3]),
    item_list_name: capitalizeWords(product_item[4]),
    currency: "GBP",
    value: Number(product_item[9].split("£").join("").replace(",", "")),
    items: [
      {
        item_id: product_item[0],
        item_name: $v_item_name,
        index: product_item[2],
        item_list_id: capitalizeWords(product_item[3]),
        item_list_name: capitalizeWords(product_item[4]),
        item_category: $v_item_category,
        item_category2: $v_item_category2,
        item_category3: product_item[6].replace("Default Title", "none"),
        item_variant: $v_item_variant,
        item_brand: "SHOKZ",
        price: Number(product_item[9].split("£").join("").replace(",", "")),
        quantity: Number(product_item[10]),
        currency: "GBP",
        discount: discount,
      },
    ],
  };

  if (buttom_name) {
    event_parameters_before.button_name = buttom_name;
  }

  window.dataLayer.push({ event_parameters: null });
  window.dataLayer.push({
    event: "ga4Event",
    event_name: event_name,
    event_parameters: event_parameters_before,
  });
}

function trackBuyCardClick($trigger, source, event_name) {
  const $buyCard = $trigger.closest(".buy-card");
  if (!$buyCard.length) return;

  // 产品数据
  let productData =
    $trigger.data("product-data") ||
    $buyCard
      .find(".variant-wrapper.active .product-data-div")
      .data("product-data");

  if (!productData) return;

  const product_item = productData.split("::");

  // 当前价格（不包含对比价）
  const priceText = $buyCard
    .find(".price.active")
    .clone()
    .children()
    .remove()
    .end()
    .text()
    .replace(/[^\d.]/g, "");

  // 对比价
  const compareText = $buyCard
    .find(".price.active .tag_sale-compare-price")
    .text()
    .replace(/[^\d.]/g, "");

  const price = parseFloat(priceText) || 0;
  const compare_at_price = parseFloat(compareText) || 0;

  const discount =
    compare_at_price > price ? +(compare_at_price - price).toFixed(2) : 0;

  // GA4
  product_page_ga4_deal_with_discount(
    product_item,
    source,
    event_name,
    discount,
  );
}
$(document).on(
  "click",
  ".valentine-may-like .buy-card .variant-img",
  function () {
    trackBuyCardClick($(this), "pic", "select_item");
  },
);
$(document).on(
  "click",
  ".valentine-may-like .buy-card .product-link",
  function () {
    trackBuyCardClick($(this), "link", "select_item");
  },
);



$(document).on(
  "click",
  ".valentine-may-like .buy-card .addtocart",
  function () {
    trackBuyCardClick(
      $(this),
      "	Add To Cart",
      "add_to_cart"
    );
  }
);
